import {MutationTree} from 'vuex';
import UserResource from '@/brief-hub/user/UserResource';
import type {ConnectedUserState} from '@/brief-hub/store/modules/connected-user/types';

export enum MutationsType {
    UPDATE_CONNECTED_USER = 'updateConnectedUser',
    UPDATE_SEARCHED_IDENTITIES = 'updateSearchedIdentities',
}

export const mutations: MutationTree<ConnectedUserState> = {
    [MutationsType.UPDATE_CONNECTED_USER]: (state: ConnectedUserState, payload: UserResource | null): void => {
        state.user = payload || undefined;
        state.searchedIdentities = payload ? [payload.identityId] : [];
    },
    [MutationsType.UPDATE_SEARCHED_IDENTITIES]: (state: ConnectedUserState, payload: string[]): void => {
        state.searchedIdentities = payload;
    },
};
